import { useCookies } from "react-cookie";
import { type CookieSettings } from "./types";
import { useCountryStateCookies } from "./useCountryStateCookies";
import { GOOGLE_TAG_MANAGER_CONSENT_COOKIE_NAME } from "./constants";
import { getDefaultNewCookieExpiration } from "./helpers";

export const useGTMConsentCookie = () => {
  const [cookies, setCookie] = useCookies([
    GOOGLE_TAG_MANAGER_CONSENT_COOKIE_NAME
  ]);
  const { isUS, state } = useCountryStateCookies();

  return {
    cookie: cookies[GOOGLE_TAG_MANAGER_CONSENT_COOKIE_NAME],
    set: (
      cookieSettings: Pick<
        CookieSettings,
        "enableOptOutCcpa" | "allowAnalytics"
      >
    ) =>
      setCookie(
        GOOGLE_TAG_MANAGER_CONSENT_COOKIE_NAME,
        cookieSettings.enableOptOutCcpa
          ? String(false)
          : // force GTM to be disabled for CA users regardless of their selection in cookie banner
            // Whenever enableOptOutCCPA is set to true Gtm should be disabled
            isUS && state === "CA"
            ? String(false)
            : String(cookieSettings.allowAnalytics),
        {
          domain: window.location.hostname,
          expires: getDefaultNewCookieExpiration(),
          path: "/"
        }
      )
  };
};
